import Vue from 'vue';

export default async function authMiddleware(to, from, next) {

  if (!to.meta.permission) {
    return true;
  }

  // view: tela de detalhe/impressão, abre mesmo com o módulo somente leitura
  let allowed = to.meta.view
    ? Vue.$acl.canView(to.meta.permission)
    : Vue.$acl.can(to.meta.permission, to.meta.write ? to.meta.module : null)

  if (!allowed) {
    return next('/')
  }

  next()
}
